/** @format */
import {differenceInCalendarDays} from 'date-fns';

const getDaysLeft = (endDate: Date): number => {
  return differenceInCalendarDays(endDate, new Date());
};

export {getDaysLeft};
